<template>
  <div class="h-screen p-0 flex flex-col gap-4 items-center bg-image">
    <div class="flex justify-center bg-black mb-4 w-full">
      <div class="flex justify-center p-5">
        <img
          :src="require('@/assets/logos/fav.png')"
          alt="logo"
          class="logo_img"
        />
      </div>
    </div>
    <form
      @submit.prevent="handleSubmit"
      class="flex justify-center w-11/12 md:w-2/4 bg-black bg-opacity-75 rounded-xl mt-10"
    >
      <div
        class="flex flex-col justify-center items-left gap-2 w-full md:w-12/12 p-10"
      >
        <div class="w-full flex flex-col gap-2 text-left">
          <h2 class="text-2xl font-semibold text-gray-100">LOGIN</h2>
          <span class="text-gray-600 font-bold"
            >Bem-vindo de volta! Insira as suas credencais para iniciar a sessão
            no MySAFETY</span
          >
        </div>

        <!-- CAMPO PARA ESCOLHER O SCHEMA -->
        <div
          class="flex items-center py-2 b-gray-300 text-gray-400 w-full gap-1"
        >
          <select
            v-model="selectedSchema"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          >
            <option value="" disabled>Escolha a Empresa</option>
            <option v-for="schema in schemas" :key="schema" :value="schema">
              {{ schema }}
            </option>
          </select>
        </div>

        <!-- CAMPO PARA EMPRESA (caso ainda use) -->
        <!-- <div class="flex items-center py-2 border-b b-gray-300 text-gray-400 w-full gap-1">
                    <div>
                        <i class="fas fa-building"></i>
                    </div>
                    <input v-model="empresa" type="text" placeholder="Empresa"
                           class="pl-2 w-9/12 py-2 border-none focus:outline-none text-gray-700">
                </div> -->

        <!-- USER -->
        <div
          class="flex items-center py-2 b-gray-300 text-gray-400 w-full gap-1"
        >
          <input
            v-model="user"
            type="text"
            placeholder="Nome de Utilizador"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
        </div>

        <!-- PASSWORD -->
        <div
          class="flex items-center py-2 b-gray-300 text-gray-400 w-full gap-1 relative"
        >
          <input
            v-model="password"
            :type="passwordFieldType"
            placeholder="Password"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <div class="absolute inset-y-0 end-2 flex items-center ps-3.5">
            <i
              :class="[
                'absolute end-2  text-gray-400 cursor-pointer',
                eyeIconClass,
              ]"
              @click="togglePasswordVisibility"
            ></i>
          </div>
        </div>

        <RouterLink to="/recuperar-password" class="text-sm text-sky-600"
          >Esqueceu a password?</RouterLink
        >

        <div class="flex justify-center py-4 w-full">
          <button
            type="submit"
            class="bg-sky-600 text-gray-100 text-lg font-semiblod p-2 w-full rounded-xl hover:bg-sky-700"
          >
            Login
          </button>
        </div>

        <div class="flex justify-center">
          <span class="msg" v-if="msg">{{ msg }}</span>
        </div>
      </div>
    </form>
    <DialogAction
      v-if="dialog_a_show"
      :propsData="dialog_a_data"
      @close="closeDalog_a"
      @confirmReturn="confirmReturn"
    />
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import { getUser } from "@/extraData";
import { mapActions } from "vuex";
import DialogAction from "@/components/dialog/actionDialog.vue";
import { aplicarCoresDoUsuario } from "@/utils/themeUtils";

export default {
  name: "AppSignIn",
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,

      // Lista de schemas carregados do servidor
      schemas: [],
      // Schema selecionado no <select>
      selectedSchema: "",

      // Demais variáveis
      dialog_a_show: false,
      dialog_a_data: {
        title: "Sessão aberta em outro dispositivo",
        message:
          "Ao fazer login, a sessão aberta em outro dispositivo será encerrada. Deseja continuar?",
        confirm: true,
        buttons: [
          {
            text: "Prosseguir",
            color: "#1f6a1fc1",
            action: "proceed",
            entity: null,
          },
          {
            text: "Cancelar",
            color: "#a83838",
            action: "cancel",
            entity: null,
          },
        ],
      },

      empresa: "",
      user: "",
      password: "",
      msg: "",
      passwordFieldType: "password",
      eyeIconClass: "fas fa-eye",
    };
  },

  components: {
    DialogAction,
  },

  mounted() {
    // Carrega a lista de schemas
    this.fetchSchemas();
    // Se ainda quiser buscar a empresa:
    // this.fetchEmpresaNome();
  },
  watch: {
    // Watch for changes in selectedSchema
    selectedSchema(newValue) {
      if (newValue) {
        this.empresa = "";
        localStorage.setItem("selectedSchema", newValue);
      }
    },
  },

  methods: {
    ...mapActions(["fetchLoggedCliente"]),

    closeDalog_a() {
      this.dialog_a_show = false;
    },
    openDialog_a() {
      this.dialog_a_show = true;
    },
    confirmReturn(action) {
      if (action === "proceed") {
        this.closeDalog_a();
        this.handleSubmit(false);
      } else {
        this.closeDalog_a();
      }
    },

    // ---- BUSCA OS SCHEMAS DO SERVIDOR ----
    async fetchSchemas() {
      try {
        const response = await fetch(`${this.baseURL}/api/v1/schemas/`);
        if (!response.ok) throw new Error("Erro ao buscar schemas.");
        const data = await response.json();
        this.schemas = data.schemas || [];
      } catch (error) {
        toast.error("Erro ao buscar schemas", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    },

    // Se ainda quiser buscar "nome da empresa" para exibir no placeholder
    async fetchEmpresaNome() {
      try {
        const response = await fetch(`${this.baseURL}/api/v1/empresa/nome/`);
        if (response.ok) {
          const data = await response.json();
          if (data && data.empresa) {
            this.empresa = data.empresa;
          } else {
            toast.error("Nenhuma empresa encontrada", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        } else {
          toast.error("Não estás associado a nenhuma empresa", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      } catch (error) {
        toast.error("Erro ao buscar nome da empresa", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    },

    // ---- SUBMIT LOGIN ----
    async handleSubmit(checkToken = true) {
      // Se você quiser obrigar o usuário a escolher um schema antes de logar:
      if (!this.selectedSchema) {
        this.msg = "É necessário selecionar um schema.";
        return;
      }

      // Se quiser obrigar campo empresa quando não for admin
      // if (!this.empresa && this.user.toLowerCase() !== 'admin') {
      //     this.msg = 'O campo Empresa é obrigatório.';
      //     return;
      // }

      const url = `${this.baseURL}/api/v1/login/`;
      const data = {
        // empresa: this.empresa,
        user: this.user,
        password: this.password,
        // Passamos o schema selecionado
        schema: this.selectedSchema,
      };

      try {
        // --- CHECAGEM PARA VER SE HÁ UMA SESSÃO ABERTA (opcional) ---
        if (checkToken) {
          const checagem = await axios.post(
            `${this.baseURL}/api/v1/login/?check=1`,
            data
          );

          if (checagem.data?.status == 200) {
            let token = checagem.data?.data?.token;
            if (token) {
              this.openDialog_a();
              return;
            }
          } else {
            this.msg = checagem.data?.data?.message;
            return;
          }
        }

        // --- LOGIN DE FATO ---
        const response = await axios.post(url, data);
        if (response.data.message === "Login feito com sucesso") {
          // Exemplo de buscar dados de cliente e guardar no localStorage
          localStorage.setItem("selectedSchema", this.selectedSchema);

          localStorage.setItem("user", JSON.stringify(response.data.data));

          localStorage.setItem(
            "token",
            JSON.stringify(response.data.data.token)
          );
          localStorage.setItem("tipo", JSON.stringify(response.data.data.tipo));
          localStorage.setItem("isLoggedIn", true);


          if (response.data.data?.tipo?.nome === "cliente") {
            try {
              const cliente = await axios.get(
                `${this.baseURL}/api/v1/cliente/${
                  response.data.data?.cliente_id ?? 0
                }/`
              );
              localStorage.setItem(
                "pickedCliente",
                JSON.stringify(cliente.data.data)
              );
            } catch (error) {
              console.error("Erro ao buscar cliente", error);
              toast.error("Erro ao fazer login", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
              return;
            }
          }

          getUser();
          // await aplicarCoresDoUsuario(this.baseURL, response.data.data.id)

          const res = await this.fetchPerfils(1);
          localStorage.setItem("userPerfil", JSON.stringify(res));
          console.log(
            "User localStorage:",
            JSON.parse(localStorage.getItem("user"))
          );
          const loggedUser = JSON.parse(localStorage.getItem("user"));
          if (loggedUser && loggedUser.tipo.nome === "tecnico") {
            this.$router.push({ name: "tecnicodashboard" });
          } else {
            this.$router.push({ name: "dashboard" });
          }
        } else {
          this.msg = response.data.message;
          localStorage.setItem("isLogged", "false");
        }
      } catch (error) {
        this.msg = "Erro ao efetuar login";
        console.error(error);
        localStorage.setItem("isLogged", "false");
      }
    },

    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.eyeIconClass =
        this.eyeIconClass === "fas fa-eye"
          ? "fa-solid fa-eye-slash"
          : "fas fa-eye";
    },

    async fetchPerfils(id) {
      try {
        const res = await axios.get(`${this.baseURL}/api/v1/perfil/1/`);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
  },
};
</script>

<style scoped>
.bg-image {
  background-color: rgba(21, 33, 49, 0.9);
  background-image: url("@/assets/img/1.png");
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  height: full;
}

.msg {
  padding: 0.5rem 0.8rem;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  text-align: center;
  background-color: rgb(252, 82, 56);
  border: 1px solid black;
  border-left: 4px solid rgb(252, 82, 56);
  width: 60%;
  color: white;
}

.logo_img {
  width: 50%;
  object-ratio: 1;
  object-fit: contain;
  border-radius: 0.3em;
  box-shadow: 0 0 0.3em 0.3em rgba(0, 0, 0, 0.1);
}
</style>
